
import { SimpleGrid } from '@chakra-ui/react';
import RSCheckboxField from '../../Checkboxes/RSCheckboxField';
const CheckBoxes=({ props, qObj, style })=> {

  const id=qObj.qid+'_checkboxes';

  return (
    <SimpleGrid
      columns={[1, null, 3]}
      spacingX="40px"
      spacingY="20px"
      id={id}
      sx={{ ...style.simpleGridCheckboxGroup}}
    >
      {qObj.options.map(option => {
        return (
          <RSCheckboxField props={props} qObj={qObj} option={option} />
        );
      })}
    </SimpleGrid>
  )
}
export default CheckBoxes;